document.addEventListener("DOMContentLoaded", () => {

    console.log("sidebar-cart loaded");

    const overlay = document.querySelector(".hgp-cart-overlay");
    const closeBtn = document.querySelector(".hgp-close-cart");

    async function openCart() {

    /* =========================================
       ALWAYS MOVE PAGE TO TOP FIRST
    ========================================= */

    window.scrollTo(0, 0);

    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;


    /* =========================================
       REFRESH CART
    ========================================= */

    await renderCart();


    /* =========================================
       NOW LOCK PAGE SCROLL
    ========================================= */

    document.body.classList.add(
        "cart-open"
    );

    document.documentElement.classList.add(
        "hgp-cart-scroll-lock"
    );

    document.body.style.overflow = "hidden";

}

    function closeCart() {

        document.body.classList.remove(
            "cart-open"
        );

        document.documentElement.classList.remove("hgp-cart-scroll-lock");



        document.body.style.overflow = "";

    }

    const cartLoader = document.querySelector(".cart-loader");

    function showCartLoader() {

        cartLoader?.classList.add("show");

    }

    function hideCartLoader() {

        cartLoader?.classList.remove("show");

    }

    window.openHGPCart = openCart;
    window.closeHGPCart = closeCart;











    overlay?.addEventListener("click", closeCart);
    closeBtn?.addEventListener("click", closeCart);



    const checkoutButton = document.querySelector(".hgp-checkout-btn");

    checkoutButton?.addEventListener("click", async () => {

        checkoutButton.disabled = true;
        checkoutButton.textContent = "Redirecting…";

        try {

            const response = await fetch("/cart.js", {
                headers: {
                    "Accept": "application/json"
                }
            });

            const cart = await response.json();

            if (!cart.item_count) {

                checkoutButton.disabled = false;
                checkoutButton.textContent = "Proceed To Checkout";

                return;
            }

            /* IMPORTANT:
               Close sidebar before leaving the page
            */
            closeCart();

            /* Allow browser state to update before redirect */
            setTimeout(() => {
                window.location.assign("/checkout");
            }, 50);

        } catch (error) {

            console.error(
                "Unable to start checkout:",
                error
            );

            /* Always close sidebar before checkout */
            closeCart();

            setTimeout(() => {
                window.location.assign("/checkout");
            }, 50);
        }
    });




    function formatMoney(value) {

        return "₹" + value.toLocaleString("en-IN");

    }










    /*===========================
        RENDER CART
    ===========================*/

    async function renderCart() {

        const cart = await fetch("/cart.js").then(r => r.json());

        const container = document.querySelector(".hgp-cart-items");

        container.innerHTML = "";

        let total = 0;

        cart.items.forEach(item => {

            const properties = item.properties || {};

            const getValidCents = (value, fallback) => {
                const cents = Number(value);
                return Number.isFinite(cents) && cents >= 0 ? cents : fallback;
            };

            // Never use `properties.selling_price`: it may be an old browser-calculated value.
            // Shopify's Cart API is the source of truth for the customer-facing sale price.
            const sellingLineCents = getValidCents(
                item.final_line_price,
                Number(item.final_price || item.price || 0) * item.quantity
            );
            const sellingPerPackCents = getValidCents(
                item.final_price,
                item.price || item.original_price || 0
            );

            // compare_price is display-only. It does not control the Shopify price.
            const comparePerPackCents = getValidCents(
                properties._hgp_compare_price || properties.compare_price,
                item.original_price || sellingPerPackCents
            );

            const selling = sellingLineCents / 100;
            const sellingPerPack = sellingPerPackCents / 100;
            const mrp = (comparePerPackCents * item.quantity) / 100;
            const saving = Math.max(0, mrp - selling);
            const discount = mrp > 0 && comparePerPackCents > sellingPerPackCents
                ? Math.round((saving / mrp) * 100)
                : 0;

            total += selling;

            container.innerHTML += `

    <div class="hgp-cart-item">

        <img src="${item.image}" class="cart-image">

        <div class="cart-content">

            <h4>${item.product_title}</h4>

            ${item.variant_title &&
                    item.variant_title !== "Default Title"
                    ? `<div class="cart-pack">${item.variant_title}</div>`
                    : ""
                }

            <div class="cart-price-row">

                ${discount > 0
                    ? `<span class="cart-compare-price">
                            ${formatMoney(mrp)}
                       </span>`
                    : ""
                }

                <span class="cart-price">
                    ${formatMoney(selling)}
                </span>

            </div>

            ${discount > 0
                    ? `<div class="cart-discount">
                        ${discount}% OFF • Save ${formatMoney(saving)}
                   </div>`
                    : ""
                }

            <div class="cart-qty">
                Qty : ${item.quantity}
            </div>

        </div>

        <button
            class="remove-item"
            data-key="${item.key}"
        >
            🗑
        </button>

    </div>

    `;

        });

        document.querySelector(".hgp-cart-total-price").textContent =
            formatMoney(total);



        /*===========================
     DELETE ITEM
 ===========================*/

        container.querySelectorAll(".remove-item").forEach(btn => {

            btn.addEventListener("click", async () => {

                btn.disabled = true;
                btn.innerHTML = "⌛";

                const response = await fetch("/cart/change.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        id: btn.dataset.key,
                        quantity: 0
                    })
                });

                if (!response.ok) {
                    console.error(await response.text());
                    btn.disabled = false;
                    btn.innerHTML = "🗑";
                    return;
                }

                await renderCart();

                const cart = await fetch("/cart.js").then(r => r.json());

                if (cart.item_count === 0) {
                    closeCart();
                }

            });

        });

    }



    /*===========================
        ADD TO CART
    ===========================*/

    async function addCurrentProduct(e) {
        e.preventDefault();

        const qty = Math.max(
            1,
            Number(document.getElementById("quantity")?.value) || 1
        );
        const activeCard = document.querySelector(".variant-card.active");
        const sellingElement = document.querySelector(".selling-price");

        const variantId = activeCard?.dataset.variantId || sellingElement?.dataset.variant;
        const sellingCents = Number(activeCard?.dataset.price || sellingElement?.dataset.price || 0);
        const compareCents = Number(
            activeCard?.dataset.compare ||
            sellingElement?.dataset.compare ||
            sellingCents
        );

        if (!variantId || !sellingCents) {
            console.error("Sidebar cart: selected Shopify variant was not found.");
            return;
        }

        showCartLoader();

        const addButton = e.currentTarget;

        if (addButton) {
            addButton.disabled = true;
            addButton.classList.add("is-adding");

            const originalText = addButton.textContent;

            addButton.dataset.originalText = originalText;
            addButton.textContent = "Adding...";
        }

        try {
            const response = await fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    id: Number(variantId),
                    quantity: qty
                })
            });

            if (!response.ok) {
                throw new Error(await response.text());
            }


            await openCart();
        } catch (error) {
            console.error("Sidebar Add to Cart failed:", error);
        } finally {

            hideCartLoader();

            if (addButton) {
                addButton.disabled = false;
                addButton.classList.remove("is-adding");

                addButton.textContent =
                    addButton.dataset.originalText || "Add to Cart";
            }
        }
    }




    const btn = document.querySelector(".hgp-add-cart");

    console.log(btn);

    btn?.addEventListener("click", addCurrentProduct);

    document.querySelector(".sticky-add-cart")
        ?.addEventListener("click", addCurrentProduct);



    function attachSidebarButtons() {

        document.querySelectorAll(".sidebar-add-cart").forEach(btn => {

            btn.onclick = async () => {

                if (btn.classList.contains("added")) return;

                showCartLoader();

                const response = await fetch("/cart/add.js", {

                    method: "POST",

                    headers: {
                        "Content-Type": "application/json"
                    },

                    body: JSON.stringify({

                        id: Number(btn.dataset.variant),

                        quantity: 1,



                    })

                });

                hideCartLoader();

                if (!response.ok) return;

                btn.innerHTML = "✓ Added";

                btn.classList.add("added");

                await renderCart();

            };

        });

    }





    /*=========================================
    RECOMMENDED PRODUCT ADD TO CART
    What's Hot + Customers Also Like
=========================================*/

    document.addEventListener("click", async (e) => {

        const button =
            e.target.closest(".related-add-cart");

        if (!button) return;

        e.preventDefault();

        /*
         * Prevent double clicking
         */
        if (button.classList.contains("adding")) {
            return;
        }

        button.classList.add("adding");

        const variantId =
            Number(button.dataset.variant);

        const sellingPrice =
            Number(button.dataset.price);

        const comparePrice =
            Number(
                button.dataset.compare ||
                button.dataset.price
            );

        const title =
            button.dataset.title || "";

        /*
         * These recommendation buttons always
         * add ONE quantity.
         */
        const qty = 1;

        /*
         * Detect Set of 2 / Set of 3 / Set of 4
         *
         * For Qty 1 we preserve Shopify's
         * original selling + compare prices.
         */
        const packMatch =
            title.match(
                /(?:set|pack)\s*(?:of)?\s*(\d+)/i
            );

        const selectedPack =
            packMatch
                ? Number(packMatch[1])
                : 1;

        /*
         * Qty is 1, therefore:
         *
         * NO dynamic quantity discount.
         *
         * Shopify's original price relationship
         * is preserved.
         */
        const finalSellingPerPack =
            sellingPrice / 100;

        const comparePerPack =
            comparePrice / 100;

        console.log("Recommended Add To Cart:", {
            variantId,
            title,
            qty,
            selectedPack,
            sellingPrice: finalSellingPerPack,
            comparePrice: comparePerPack
        });

        /*
         * Same cart loading animation
         * as main Add to Cart.
         */
        showCartLoader();

        try {

            const response =
                await fetch("/cart/add.js", {

                    method: "POST",

                    headers: {
                        "Content-Type": "application/json"
                    },

                    body: JSON.stringify({

                        id: variantId,

                        quantity: qty,



                    })

                });


            if (!response.ok) {

                console.error(
                    await response.text()
                );

                return;

            }


            /*
             * Render the cart using the
             * SAME cart renderer.
             */
            await renderCart();


            /*
             * Same animation timing as
             * main Add to Cart.
             */
            setTimeout(() => {

                hideCartLoader();

                openCart();

            }, 300);


        } catch (error) {

            console.error(
                "Recommended Add To Cart error:",
                error
            );

        } finally {

            button.classList.remove("adding");

        }

    });







    /* =========================================================
   RESET CART SIDEBAR WHEN RETURNING TO THE PAGE
========================================================= */

    window.addEventListener("pageshow", () => {

        /* Always close sidebar */
        closeCart();

        /* Reset checkout button */
        const checkoutButton =
            document.querySelector(".hgp-checkout-btn");

        if (checkoutButton) {

            checkoutButton.disabled = false;

            checkoutButton.textContent =
                "Proceed To Checkout";
        }

    });

});